var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"px-1",class:_vm.scoreColor},[_c('strong',[_vm._v(_vm._s(_vm.scoreText))]),(_vm.rating === 3)?_c('span',[_vm._v(" "),_c('v-icon',{attrs:{"x-small":"","color":"white"}},[_vm._v("mdi-thumb-up-outline")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }